import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetAllDenominationsResData } from "./GetAllDenominationsResData";

const ENDPOINT = "/security/denominations";

export class GetAllDenominationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params = null;

    constructor() {
        super();
    }

    public async execute(): Promise<GetAllDenominationsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetAllDenominationsResData(res);
    }
}

export class GetImportableTemplateReqData {
    installationName: string;
}
